import { Component, OnInit, ViewChild} from '@angular/core';
import {DigitalSignatureDialogInfoComponent} from '../digital-signature-dialog-info/digital-signature-dialog-info.component';
import {DigitalSignatureRectangleDialogComponent} from '../digital-signature-rectangle-dialog/digital-signature-rectangle-dialog.component';
import {ActivatedRoute, Router} from '@angular/router';
import {DigitalSignatureService} from '../service/digital-signature.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {PdfViewerComponent} from 'ng2-pdf-viewer';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-digital-signature-rectangle-create',
  templateUrl: './digital-signature-rectangle-create.component.html',
  styleUrls: ['./digital-signature-rectangle-create.component.scss']
})
export class DigitalSignatureRectangleCreateComponent implements OnInit {

  pdfSrc: any | undefined;
  startX = 0;
  startY = 0;
  layerX = 0;
  layerY = 0;
  width = 0;
  height = 0;
  isDrawing = false;
  currentPage = 0;
  pageHeight = 0;
  page = 1;
  totalPages = 0;
  rectStartX = 0;
  rectStartY = 0;
  scrollY = 0;
  scalePercent = 0;
  pdfSignedLoaded = false;
  private pageWidth = 0;
  documentUUID?: string | null;
  fileName?: string | null;
  public safePdfUrl: SafeResourceUrl | undefined;

  @ViewChild(PdfViewerComponent, {static: false})
  private pdfComponent?: PdfViewerComponent;


  constructor(private sanitizer: DomSanitizer,
              private digitalSignatureService: DigitalSignatureService,
              public dialog: MatDialog,
              private route: ActivatedRoute,
              private router: Router
              ) { }

  ngOnInit(): void {
    this.documentUUID = this.route.snapshot.paramMap.get('documentUUID');
    this.fileName = this.route.snapshot.paramMap.get('fileName');
    this.downloadDocument();
  }
  reloadComponent(){
    window.location.reload();
  }

  loadComplete($event: any) {
    this.totalPages = $event.numPages;
  }

  onMouseMove(event: any) {
    if (!this.isDrawing) { return; }

    const rect = (event.target as HTMLElement).getBoundingClientRect();

    const currentX = event.clientX - rect.left + window.scrollX; // luăm în considerare scroll-ul orizontal
    const currentY = event.clientY - rect.top + this.scrollY; // luăm în considerare scroll-ul vertical

    const widthDifference = currentX - this.startX;
    const heightDifference = currentY - this.startY + 50;

    if (widthDifference < 0) {
      this.rectStartX = currentX;
      this.width = -widthDifference; // folosim valoarea pozitivă
    } else {
      this.rectStartX = this.startX;
      this.width = widthDifference;
    }

    if (heightDifference < 0) {
      this.rectStartY = currentY;
      this.height = -heightDifference; // folosim valoarea pozitivă
    } else {
      this.rectStartY = this.startY;
      this.height = heightDifference;
    }

    if (this.width > 100) {
      this.width = 100;
    }

    if (this.height > 50) {
      this.height = 50;
    }
  }

  onWheel(event: any) {
    this.scrollY += event.deltaY;
  }

  onMouseDown(event: any) {
    this.startX = event.layerX;
    this.startY = event.layerY;
    this.width = 0;
    this.height = 0;
    this.isDrawing = true;
  }

  onMouseUp() {
    this.isDrawing = false;
    this.currentPage = this.page - 1;
    // only for debug purpose
    // console.log('Inaltime detectata fata de marginea de sus: ', this.startY);
    // console.log('Latime detectata fata de partea din stanga: ', this.startX);
    // console.log('Pagina curenta: ', this.currentPage);
    // console.log('Inaltimea unei pagini este: ',  this.pageHeight);
    // console.log('Latimea unei pagini este: ',  this.pageWidth);
    // console.log('Procentul la care este scalata pagina PDF: ', this.scalePercent);
    const startXReal = this.startX / (this.scalePercent / 100);
    const startYReal = this.startY / (this.scalePercent / 100);
    const pageHeightReal = this.pageHeight / (this.scalePercent / 100);
    const pageWidthReal = this.pageWidth / (this.scalePercent / 100);
    const requestBody = {
      startX: startXReal,
      startY: startYReal,
      pageHeight: pageHeightReal,
      pageWidth: pageWidthReal,
      page: this.currentPage,
      documentUUID: this.documentUUID,
      fileName: this.fileName
    };
    // only for debug purpose
    // console.log(requestBody);
    this.openDialog(requestBody);
  }

  openDialog(data: any): void {
    const dialogRef = this.dialog.open(DigitalSignatureRectangleDialogComponent, {
      width: '600px',
      height: '300px',
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
      if (result) {
        localStorage.setItem('signedDocumentUUID', result);
        this.router.navigateByUrl(`/semnatura/get-signed-document/${result}`);
      }
      // this.reloadComponent();
    });
  }
  openDialogInfo() {
    this.dialog.open(DigitalSignatureDialogInfoComponent, {
      width: '600px',
      height: '300px'
    });
  }

  downloadDocument() {
    if (this.documentUUID) {
      this.digitalSignatureService.getDocumentThatWillBeSigned(this.documentUUID).subscribe(data => {
        this.pdfSrc = data;
        this.openDialogInfo();
      });
    }
  }

  goToFirstPage() {
    this.page = 1;
  }

  goToLastPage() {
    this.page = this.totalPages;
  }

  pageInitialized(e: CustomEvent) {
  }

  getEvent(event: any) {
    this.pageHeight = event.source.height; // înălțimea presupusă pentru o pagină
    this.pageWidth = event.source.width;
    if (this.pdfComponent){
      if (this.scalePercent === 0){
        this.scalePercent = this.pdfComponent.pdfViewer._location?.scale;
      }
      this.pdfComponent.pdfViewer.currentScaleValue = 'page-fit';
    }

  }

  prevPage() {
    if (this.page > 1) {
      this.page -= 1;
    }
  }

  nextPage() {
    if (this.page < this.totalPages) {
      this.page += 1;
    }
  }
}
